"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CLUSTER_ACTION;
(function (CLUSTER_ACTION) {
    CLUSTER_ACTION[CLUSTER_ACTION["REMOVE"] = 1] = "REMOVE";
    CLUSTER_ACTION[CLUSTER_ACTION["STATUS"] = 2] = "STATUS";
})(CLUSTER_ACTION = exports.CLUSTER_ACTION || (exports.CLUSTER_ACTION = {}));
//# sourceMappingURL=cluster.js.map